import { render, staticRenderFns } from "./TxAdvHc.vue?vue&type=template&id=60439f50&scoped=true"
import script from "./TxAdvHc.vue?vue&type=script&lang=js"
export * from "./TxAdvHc.vue?vue&type=script&lang=js"
import style0 from "./TxAdvHc.vue?vue&type=style&index=0&id=60439f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60439f50",
  null
  
)

export default component.exports